import Box from "@mui/material/Box";
import PageVersionContext from "components/PageVersionContext";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import sanitizeHtml from "sanitize-html";
import EulerianService from "services/EulerianService";
import { normalized } from "utils/urlUtils";

export const componentClassName = "Da-Text";

const textStyled = {
  width: "100%",
  backgroundImage: "none",
  "& a": {
    color: "var(--text-action-high-blue-france)",
  },
  "& a[target=_blank]:after": {
    content: `"\\f08e"`,
    fontSize: "12px",
    fontFamily: `"Font Awesome 5 Pro"`,
    pl: 0.5,
  },
};

const sanitizerOptions = {
  ...sanitizeHtml.defaults,
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(["h2", "img", "u", "s", "sub", "address", "sup"]),
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    "*": ["id", "class", "style", "title"],
    a: ["href", "name", "target"],
    img: ["src", "target", "alt"],
  },
  allowedSchemesByTag: {
    ...sanitizeHtml.defaults.allowedSchemesByTag,
    img: ["https", "data"],
  },
};

const Text = (props) => {
  const { children = null, sx = {}, highlight = false, ...others } = props;

  const childrenProps = {};
  let childrenDecode = children;
  if (typeof children === "string") {
    try {
      childrenDecode = decodeURIComponent(children);
    } catch (e) {
      // do nothing
    }
  } else {
    childrenDecode = children?.props?.data || "";
  }
  const content = sanitizeHtml(childrenDecode, sanitizerOptions);
  if (content.includes("<h2>")) {
    const contentArray = content.split("<h2>");
    if (Array.isArray(contentArray)) {
      contentArray.forEach((ca) => {
        if (ca.includes("</h2>")) {
          const title = ca.split("</h2>")[0];
          childrenDecode = childrenDecode.replace(
            "<h2>",
            `<h2 id="${normalized(title.replaceAll(/<\/?([a-z])*>/g, ""))}">`,
          );
        }
      });
    }
  }
  if (typeof children === "string") {
    childrenProps.dangerouslySetInnerHTML = { __html: childrenDecode };
  } else {
    childrenProps.children = childrenProps.children?.props?.data
      ? {
          ...children,
          props: { ...children.props, data: childrenDecode },
        }
      : children;
  }

  const { currentPageVersion } = useContext(PageVersionContext);
  const { breadcrumb = [] } = currentPageVersion || {};

  const handleClick = (e) => {
    const targetIsLink = e.target && e.target.tagName && e.target.tagName.toLowerCase() === "a";
    if (breadcrumb && targetIsLink) {
      EulerianService.sendClick({ link: [`link::click::${e.target?.firstChild?.nodeValue?.toLowerCase() || ""}`] });
    }
  };

  return (
    <Box
      component="p"
      sx={(theme) => ({
        ...textStyled,
        ...sx,
        boxShadow: highlight ? `inset .22rem 0 0 0 ${theme.palette.secondary.main}` : "none",
      })}
      className={`${componentClassName} ${highlight ? " fr-highlight" : ""}`}
      {...childrenProps}
      {...others}
      onClick={handleClick}
    />
  );
};

Text.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.shape(),
  highlight: PropTypes.bool,
};

export default Text;
